<template>
    <div>
        <h1 class="title">Redis Queue</h1>
        <br/><br/>
        <table class="table is-bordered" align="center">
          <tbody>
              <tr v-for="(queueLen, queueName) in redis_queues">
                <td>{{  formatQueueName(queueName)  }}</td>
                <td>{{queueLen}}</td>
                <td>
                  <b-button type='is-primary' class="button flex-pulled-right" expanded @click="confirmDelete(queueName)">Clear Queue</b-button>
                </td>
              </tr>
          </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios'
import auth from '../auth'

export default {
  name: 'RedisQueue',
  computed: {},
  data () {
    return {
      redis_queues: {}
    }
  },
  created () {
    auth.checkAuth(['read_redis_queue'])
    this.fetchData()
  },
  methods: {
    fetchData () {
      const loadingComponent = this.$buefy.loading.open({ container: null })
      axios.get(this.$constants.GET_REDIS_QUEUE)
        .then(response => {
          this.redis_queues = response.data
          console.log(this.redis_queues)
          loadingComponent.close()
        })
        .catch(error => {
          this.redis_queues = {}
          console.log(error.msg)
        })
        .finally(resp => {
          loadingComponent.close()
        })
    },
    confirmDelete (queueName) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Queue',
        message: 'The queue will be cleared. Are you sure you want to delete the queue?',
        confirmText: 'Delete Queue',
        type: 'is-danger',
        onConfirm: () => {
          this.clearQueue(queueName)
        }
      })
    },
    clearQueue (queueName) {
      const loadingComponent = this.$buefy.loading.open({ container: null })
      axios.delete(this.$constants.DELETE_REDIS_QUEUE + queueName)
        .then(response => {
          loadingComponent.close()
          this.$buefy.toast.open('Queue deleted!')
        })
        .catch(error => {
          console.log(error.msg)
          this.$buefy.toast.open(error.msg)
        })
        .finally(resp => {
          loadingComponent.close()
          this.fetchData()
        })
    },
    has_permissions (permissions) {
      return permissions.every(auth.hasPermission, auth.getPermissions())
    },
    onPageChange (page) {
      this.page = page
      this.fetchData()
    },
    formatQueueName (queue) {
      const queueName = {
        sage: 'Sage Queue',
        clearance: 'Sage Clearance Queue',
        celery: 'Celery/Icefall Queue',
        icefall: 'Icefall Backup Queue'
      }
      return queueName[queue] ? queueName[queue] : queue
    }
  }
}

</script>
